export default __webpack_public_path__ + "static/media/categories-bg.1d8bf7e5.png";